import React from 'react';
import * as S from './styles';

type Size = 'xsm' | 'sm' | 'md' | 'lg';
type Variant = 'primary' | 'secondary' | 'positive' | 'tertiary' | 'coopercred' | 'danger' | 'dev'
type IconPosition = 'left' | 'right';

export type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  size: Size;
  full?: boolean;
  variant?: Variant;
  iconName?: string;
  iconPosition?: IconPosition;
  alertBadge?: boolean
  type?: 'button' | 'submit' | 'reset' | undefined;
}

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(({
  children,
  size,
  iconName,
  iconPosition = 'left',
  variant = 'primary',
  disabled = false,
  full = false,
  alertBadge = false,
  type = 'button',
  ...props
}: React.PropsWithChildren<ButtonProps>, forwardRef) => {
  return (
    <S.Button
      full={full}
      disabled={disabled}
      size={size}
      variant={variant}
      ref={forwardRef}
      type={type}
      {...props}
    >
      {iconName && iconPosition === 'left' && (
        <S.ButtonIcon icon={iconName} $iconPosition={iconPosition} width={15} />
      )}
      {children}
      {iconName && iconPosition === 'right' && (
        <S.ButtonIcon icon={iconName} $iconPosition={iconPosition} $hasChildren={children != null} width={15} />
      )}
      {alertBadge && (
        <div style={{ backgroundColor: 'red', width: 7, height: 7, borderRadius: 50, alignSelf: 'flex-start', marginLeft: -5 }}></div>
      )}
    </S.Button>
  );
});
